import { SelfPublishesStore } from '.';

export const selectSelfPublishesState = (store: SelfPublishesStore) => store.selfPublishes.selfPublishes;
